var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { disabled: _vm.disabled, "non-selectable": _vm.disabled },
      on: {
        click: function($event) {
          _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "span",
        {
          ref: "duration",
          staticClass:
            "text-faded q-px-sm q-py-xs cursor-pointer round-borders hover-highlight"
        },
        [_vm._v("\n    " + _vm._s(_vm.durationFormatted) + "\n  ")]
      ),
      _c(
        "validating-popover",
        {
          staticClass: "duration-popover",
          attrs: { disabled: _vm.disabled },
          on: { show: _vm.handleShowPopover, hide: _vm.handleHidePopover }
        },
        [
          _c("div", { staticClass: "q-pa-md" }, [
            _c("div", { staticClass: "row items-center gutter-x-sm" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "block q-mb-sm" }, [
                    _c("span", { staticClass: "q-subheading text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("start")))
                    ])
                  ]),
                  _c("time-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required|length:4",
                        expression: "'required|length:4'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: { name: "startedAt", date: _vm.startedAtDate },
                    on: {
                      clickDate: function($event) {
                        _vm.handleSelectedDate("start")
                      }
                    },
                    model: {
                      value: _vm.startedAtTime,
                      callback: function($$v) {
                        _vm.startedAtTime = $$v
                      },
                      expression: "startedAtTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "block q-mb-sm" }, [
                    _c("span", { staticClass: "q-subheading text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("stop")))
                    ])
                  ]),
                  _c("time-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: _vm.isStopped ? "required|length:4" : "",
                        expression: "isStopped ? 'required|length:4' : ''",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: { name: "stoppedAt", date: _vm.stoppedAtDate },
                    on: {
                      clickDate: function($event) {
                        _vm.handleSelectedDate("stop")
                      }
                    },
                    model: {
                      value: _vm.stoppedAtTime,
                      callback: function($$v) {
                        _vm.stoppedAtTime = $$v
                      },
                      expression: "stoppedAtTime"
                    }
                  })
                ],
                1
              )
            ]),
            _vm.errors.has("startedAt") || _vm.errors.has("stoppedAt")
              ? _c("div", { staticClass: "text-negative q-mt-sm" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.errors.first("startedAt") ||
                          _vm.errors.first("stoppedAt")
                      ) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ]),
          _c("q-datetime-picker", {
            staticClass: "no-border",
            attrs: { minimal: "" },
            model: {
              value: _vm.date,
              callback: function($$v) {
                _vm.date = $$v
              },
              expression: "date"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }